export default "__VITE_ASSET__D97uu4y4__"